(ns common.schema.entities.workspace.kyc.templates.lifeline.company-config)

(def contact-email "finance@lifelineventures.com")
